const NAME = "AUTOMATIC_PROCESSES";

export default NAME;
